import React from 'react';

import './App.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Layout from './Layout/Layout';
import Inicio from './Pages/Inicio/Inicio';
import Galeria from './Pages/Galeria/Galeria';
import Terminos from './Pages/Terminos/Terminos';
import Politicas from './Pages/Politicas/Politicas';

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/inicio" element={<Inicio/>}/>
          <Route path="/terminos-servicios" element={<Terminos/>}/>
          <Route path="/politica-de-privacidad" element={<Politicas/>}/>
          <Route path="/galeria" element={<Galeria/>}/>
          <Route path="*" element={<Navigate to="/inicio" replace />} />
        </Routes>
      </Layout>

    </BrowserRouter>
  );
}

export default App;
